module.exports = __webpack_public_path__ + "img/shop.a46bcf6f.svg";